import { api } from './apiClient';

export type ClinicalAlert = {
  patientId: string;
  patientName: string;
  cycleId?: string;
  type: string;
  severity: 'high' | 'medium' | 'low';
  message: string;
};

export type DashboardSummary = {
  totalPatients: number;
  totalCycles: number;
  evolutionRate: number | null;
  alerts: ClinicalAlert[];
};

export function fetchDashboardSummary(): Promise<DashboardSummary> {
  return api.get<DashboardSummary>('/dashboard/summary');
}
